import API from "../../util/api";

export default {
  getDeadline() {
    return API.get(`/member/deadline`);
  },
  updateDeadline(payload) {
    return API.post("/member/deadline", { deadline_list: payload });
  },
  getPatentDeadline(payload) {
    return API.get(`/asset/patent/deadline`, { params: payload });
  },
  /** @deprecated getPatentDeadline 사용 (특사 x-company-idx 자동 부착) */
  getPatentDeadlineAsAgent(company_idx, payload) {
    return this.getPatentDeadline(payload);
  },
  getTradeMarkDeadline(payload) {
    return API.get(`/asset/trademark/deadline`, { params: payload });
  },

  getTradeMarkNoticeDeadline() {
    return API.get(`/member/deadline/trademark`);
  },

  updateTradeMarkDeadline(payload) {
    return API.post(`/member/deadline/trademark`, { deadline_list: payload });
  },
};
